export default "__VITE_ASSET__DT6eJ381__"